import { applyMiddleware, combineReducers, compose, createStore } from 'redux'
import {
  initializeCurrentLocation,
  routerForBrowser,
} from 'redux-little-router'
import { Provider } from 'react-redux'
import $ from 'jquery'
import Cookies from 'js-cookie'
import imagesLoaded from 'imagesloaded'
import React from 'react'
import ReactDOM from 'react-dom'
import scroll from 'scroll-speed'
import thunk from 'redux-thunk'
import { pageHeaderHeightWasSet, windowWasScrolled } from './actions/app'
import { documentWasClickedOutsideOfOpenFilter } from './actions/filter'
import App from './components/App'
import BackToProjects from './components/BackToProjects'
import getVenuesSettings from './getVenuesSettings'
import ensureValidProjectsQueryString from './ensureValidProjectsQueryString'
import { fetcher, lastProjectsUrlSetter } from './middleware'
import KeywordSearch from './components/KeywordSearch'
import PreviousAndNextVenues from './components/PreviousAndNextVenues'
import reducers from './reducers'
import VenueMap from './components/VenueMap'

require('./sass/index.sass')
require('slick-carousel/slick/slick.css')
require('slick-carousel')
require('react-virtualized/styles.css')

function createObjectFitFallbacks (containerSelector) {
  if ( ! Modernizr.objectfit ) {
    $(containerSelector).each(function () {
      var $container = $(this),
          imgUrl = $container.find('img').prop('src')
      if (imgUrl) {
        $container
          .css('backgroundImage', 'url(' + imgUrl + ')')
          .addClass('no-objectfit-item')
      }
    });
  }
}

$(document).ready(() => {

  // Keyword search.
  ReactDOM.render(
    <KeywordSearch />,
    $('#keyword-search').get(0),
  )

  // Homepage.
  if ($('body.page-node-type-homepage').length > 0) {
    imagesLoaded.makeJQueryPlugin($)
    const $slider = $('.field--name-field-slider')
    $slider.imagesLoaded().done(() => {
      $slider.slick({
        arrows: false,
        dots: true,
      })
    })
    createObjectFitFallbacks('.field--name-field-featured-projects > .field__items > .field__item .field--type-image')
  }

  // Projects.
  if ($('body.page-node-type-projects-page').length > 0) {
    ensureValidProjectsQueryString(getVenuesSettings().filterOptionsFromEs)
    $('nav > ul.menu li:first-child a').addClass('selected')
    const routes = {
      '/': true,
      '/(:first)': true,
      '/(:first)/(:second)': true,
    }
    const { reducer, middleware, enhancer } = routerForBrowser({
      routes,
      basename: '/projects',
    })
    const appMiddleware = [lastProjectsUrlSetter, fetcher, middleware, thunk]
    const store = createStore(
      combineReducers({
        ...reducers,
        router: reducer,
      }),
      compose(enhancer, applyMiddleware(...appMiddleware)),
    )
    store.dispatch(pageHeaderHeightWasSet($('header').height()))
    const speed = scroll()
    speed.on('scroll', () => {
      store.dispatch(windowWasScrolled(window.scrollY, speed[1]))
      speed.flush()
    })
    $(document).on('click', (event) => {
      const isClickOnOpenFilter = $(event.target).parents('div.filter').find('button.is-open').length > 0
      if (isClickOnOpenFilter) {
        return
      }
      store.dispatch(documentWasClickedOutsideOfOpenFilter())
    })
    const initialLocation = store.getState().router
    if (initialLocation) {
      store.dispatch(initializeCurrentLocation(initialLocation))
    }
    ReactDOM.render(
      <Provider store={store}>
        <App />
      </Provider>,
      $('article.node--type-projects-page > .node__content').get(0),
    )
  }

  // Project.
  if ($('body.page-node-type-venue').length > 0) {
    createObjectFitFallbacks('.field--name-field-images-and-metadata > .field__item .inner')
    const $els = $('.facts-and-figures-toggle').add('.facts-and-figures-map')
    $('button.facts-and-figures-is-open').on('click', () => {
      $els.removeClass('is-open')
    })
    $('button.facts-and-figures-is-closed').on('click', () => {
      $els.addClass('is-open')
      if (getVenuesSettings().location !== null) {
        ReactDOM.render(
          <VenueMap location={getVenuesSettings().location} />,
          $('#venue-map').get(0),
        )
      }
    })
    const currentNid = parseInt(getVenuesSettings().currentNid, 10)
    let pathnameSearch = Cookies.get('pathnameSearch')
    if (pathnameSearch === undefined) {
      pathnameSearch = ''
    }
    Cookies.remove('pathnameSearch')
    if (pathnameSearch !== '') {
      ReactDOM.render(
        <BackToProjects pathnameSearch={pathnameSearch} />,
        $('#back-to-projects').get(0),
      )
      if (pathnameSearch.indexOf('/map') === -1) {
        ReactDOM.render(
          <PreviousAndNextVenues
            currentNid={currentNid}
            pathnameSearch={pathnameSearch}
          />,
          $('#previous-and-next-venues').get(0),
        )
      }
    }
    const $items = $('.field--name-field-images-and-metadata > .field__item')
    $items.on('click', (event) => {
      const $clicked = $(event.currentTarget)
      const index = $items.index($clicked)
      const $lightbox = $('.lightbox')
      const $images = $lightbox.find('.images')
      const $readoutCurrent = $lightbox.find('.readout > span.current')
      $(document).on('keydown', (event) => {
        switch (event.which) {
          case 27:
            $lightbox.removeClass('is-open')
            $images.slick('unslick')
            $('body').css('overflow', 'visible')
            $(document).off('keydown')
            break
          case 37:
            $images.slick('slickPrev')
            break
          case 39:
            $images.slick('slickNext')
            break
          default:
            break
        }
      })
      $lightbox.addClass('is-open').find('.closer').one('click', () => {
        $lightbox.removeClass('is-open')
        $images.slick('unslick')
        $('body').css('overflow', 'visible')
        $(document).off('keydown')
      })
      $images.slick({
        initialSlide: index,
      })
      $readoutCurrent.html((index + 1).toString())
      $images.on('afterChange', (slick, currentSlide, nextSlide) => {
        const number = ($images.slick('slickCurrentSlide') + 1).toString()
        $readoutCurrent.html(number)
      })
      $('body').css('overflow-y', 'hidden')
    })
  }
})
